import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { ArticleItem } from '@/mocks/categoryData';

interface ArticleCardProps {
  article: ArticleItem;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to="/"
      className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-100/80"
    >
      <div className="relative w-full h-48 md:h-56 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          title={article.title}
        />
        <span className="absolute top-3 left-3 inline-block px-2.5 py-1 rounded-full bg-accent-500/90 text-white text-xs font-semibold whitespace-nowrap">
          {article.tag}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors duration-300 line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200/70">
          <div className="flex items-center gap-2 text-xs text-foreground-400">
            <span>{article.category}</span>
            <span>·</span>
            <span>{article.date}</span>
          </div>
          <span className="text-xs text-foreground-400">
            {(article.views / 10000).toFixed(0)}万 {t('category.views')}
          </span>
        </div>
      </div>
    </Link>
  );
}